import { motion } from "framer-motion";
import { BRAND } from "@/data/content";
import { DownloadButtons } from "@/sections/DownloadButtons";
import { useLang } from "@/i18n/LanguageContext";

export const CTASection = () => {
    const { t } = useLang();
    return (
        <section
            id="download"
            data-testid="cta-section"
            className="relative py-2 sm:py-4 overflow-hidden"
        >
            <div className="absolute inset-0">
                <div className="absolute inset-0 bg-gradient-to-bl from-[var(--primary)]/30 via-black to-black" />
                <div className="absolute -bottom-20 -right-20 w-[500px] h-[500px] bg-[var(--primary)]/30 blur-[150px] rounded-full" />
            </div>

            <div className="relative max-w-5xl mx-auto px-5 sm:px-8 text-center">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <img
                        src={BRAND.logo}
                        alt="606FITNESS"
                        className="h-44 sm:h-60 lg:h-72 mx-auto -my-4 sm:-my-6 w-auto object-contain"
                    />
                    <h2 className="text-4xl sm:text-6xl lg:text-7xl font-black leading-[1.05]">
                        {t.cta.h2Top}{" "}
                        <span className="text-gradient-orange">{t.cta.h2Bottom}</span>
                    </h2>
                    <p className="mt-6 text-lg sm:text-xl text-neutral-300 max-w-2xl mx-auto leading-relaxed">
                        {t.cta.desc}
                    </p>
                    <div className="mt-10 flex justify-center">
                        <DownloadButtons testIdPrefix="cta-" />
                    </div>
                </motion.div>
            </div>
        </section>
    );
};
